import { render, staticRenderFns } from "./BillingAddressForm.vue?vue&type=template&id=be05c554&scoped=true&"
import script from "./BillingAddressForm.vue?vue&type=script&lang=ts&"
export * from "./BillingAddressForm.vue?vue&type=script&lang=ts&"
import style0 from "./BillingAddressForm.vue?vue&type=style&index=0&id=be05c554&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be05c554",
  null
  
)

export default component.exports